import {ViewType} from "../../../../core/gd/const/views/view-type"
import {ProjectViewAccess} from "../../../../core/model2/project-view/@const"

const debug = false
// const debug = "togglePinFormAction"

export default async function togglePinFormAction(id: ID) {
    debug && console.log(debug, 'togglePinFormAction', id)

    const form = _.find(gd.projectViews.project.properties.forms as any[], form => form.id === id)

    await gd.projectViews.createView({
        systemType  : ViewType.PROJECT_REQUEST_FORMS,
        id          : id,
        name        : form.name,
        access      : ProjectViewAccess.PUBLIC,
        isPinned    : true,
    })
}